import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {Act, Chapter} from "./story";
import {headers} from "./headers";
import {Tag} from "./fields";
import {host} from "./api";

export interface ChapterState {
    chapters: Array<Chapter>,
    status: Status,
    chapter: Chapter | undefined,
    error: string | null | undefined
}

const initialState: ChapterState = {
    chapters: [],
    status: Status.Idle,
    chapter: undefined,
    error: null,
}

export const fetchChapters = createAsyncThunk('fetchChapters', async (params: {projectId: number, actId: number}) => {
    const response = await axios.get(`${host}/acts/${params.actId}/chapters`, {
        headers: headers(params.projectId?.toString())
    })
    return response.data
})

export const fetchChapter = createAsyncThunk('fetchChapter', async (params: {projectId: number, chapterId: number}) => {
    const response = await axios.get(`${host}/chapters/${params.chapterId}`, {
        headers: headers(params.projectId?.toString())
    })
    return response.data
})

export const saveChapter = createAsyncThunk('saveChapter', async (params: { projectId: number, chapter: Chapter }) => {
    const response = await axios.post(`${host}/chapters`,
        params.chapter,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})


export const deleteChapter = createAsyncThunk('deleteChapter', async (params: { projectId: number, chapterId: number }) => {
    const response = await axios.delete(`${host}/chapters/${params.chapterId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const removeChapterTag = createAsyncThunk('removeChapterTag', async (params: { projectId: number, chapterId: number, tagId: number }) => {
    const response = await axios.delete(`${host}/chapters/${params.chapterId}/tags/${params.tagId}`,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const addChapterTag = createAsyncThunk('addChapterTag', async (params: { projectId: number, chapterId: number, tag: Tag }) => {
    const response = await axios.post(`${host}/chapters/${params.chapterId}/tags`,
        params.tag,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const chaptersSlice = createSlice({
    name: 'chapters',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            .addCase(fetchChapters.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchChapters.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.chapters = action.payload
            })
            .addCase(fetchChapters.rejected, (state, action) => {
                state.status = Status.Failed
                state.error = action.error.message
            })
            .addCase(removeChapterTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(removeChapterTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addChapterTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addChapterTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(saveChapter.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveChapter.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(fetchChapter.pending, (state, action) => {
                state.status = Status.Loading
                state.chapter = undefined
            })
            .addCase(fetchChapter.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.chapter = action.payload
            })
            .addCase(deleteChapter.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteChapter.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
    }
})

export default chaptersSlice.reducer;